// extracted by mini-css-extract-plugin
export default {"buttonSave":"CookiePreference_buttonSave__8Bgqt","buttonClose":"CookiePreference_buttonClose__vanGu"};